import { render, staticRenderFns } from "./Encuentranos.vue?vue&type=template&id=dc912c18&scoped=true&"
import script from "./Encuentranos.vue?vue&type=script&lang=js&"
export * from "./Encuentranos.vue?vue&type=script&lang=js&"
import style0 from "./Encuentranos.vue?vue&type=style&index=0&id=dc912c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc912c18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
